import { useContext } from 'react'

import { ProductQuickAddContext } from '@lib/product/quick-add-context'

const QuickAddModalBackdrop = () => {
  const { closeProductQuickAdd } = useContext(ProductQuickAddContext)

  return (
    <div
      onClick={closeProductQuickAdd}
      className="absolute inset-0 z-0 bg-backdrop bg-opacity-25"
    />
  )
}

export default QuickAddModalBackdrop
